export default __webpack_public_path__ + "static/webtrust-br-min-1a38728f5608f1b5e7e69ff31bbbb4b9.png";